<template>
  <div>
    <Header text="" class="mb-3" go-back />
    <div class="row">
      <div class="col-md-8 mb-5">
        <Cart isCheckout hideCart hideHeader />
      </div>
      <form class="form card p-5 col-md-4" id="utd-form">
        <div class="form-group">
          <div class="grid grid-cols-2-res">
            <div>
              <label for="">Voornaam *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                name="Voornaam"
                required
              />
            </div>
            <div>
              <label for="">Achternaam *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                name="Achternaam"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="grid grid-cols-1-res">
            <div>
              <label for="">Bedrijfsnaam (optional)</label>
              <input
                type="text"
                class="form-control utd-form-item"
                name="Bedrijfsnaam"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="grid grid-cols-1-res">
            <div>
              <label for="">Country / Region *</label>
              <select
                class="form-control utd-form-item"
                required
                name="Country/Region"
              >
                <option selected default>Select a country / region…</option>
                <option value="België">België</option>
                <option value="Nederland">Nederland</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group mt-4">
          <h4>Adres</h4>
          <div class="">
            <div>
              <label for="">Straatnaam huisnummer *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                required
                name="Straatnaam huisnummer"
              />
            </div>
            <div>
              <label for="">Postcode *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                required
                name="Postcode"
              />
            </div>
            <div>
              <label for="">Plaats *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                required
                name="Plaats"
              />
            </div>
          </div>
        </div>

        <div class="form-group mt-4">
          <h4>Contact</h4>
          <div class="grid grid-cols-2-res">
            <div>
              <label for="">Telefoon *</label>
              <input
                type="text"
                class="form-control utd-form-item"
                required
                name="Telefoon"
              />
            </div>
            <div>
              <label for="">E-mailadres *</label>
              <input
                type="email"
                class="form-control utd-form-item"
                required
                name="E-mailadres"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="mt-5 text-center">
            <input
              type="submit"
              value="Verzenden"
              class="btn btn-primary"
              style="max-width: 260px"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Cart from "./Cart.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("cart");
export default {
  name: "Checkout",
  components: {
    Cart,
    Header,
  },
  computed: {
    ...mapGetters(["totalPrice"]),
    ...mapState({
      cartItems: "items",
    }),
  },
  mounted() {
    let processForm = (e) => {
      e.preventDefault();
      let utdFormData = {};
      const utdFormFields = document.querySelectorAll(
        "#utd-form .utd-form-item"
      );

      utdFormFields.forEach((data) => {
        let $target = data;
        let attr = $target.getAttribute("name");
        let val = $target.value;
        utdFormData[attr] = val;
      });

      this.cartItems.map((cartItem) => {
        utdFormData[
          `Product [${cartItem.name}]`
        ] = `${cartItem.quantity} piece/s`;
      });

      utdFormData["totaal"] = this.totalPrice;

      const http = new XMLHttpRequest();
      http.open(
        "POST",
        "https://www.uptodateconnect.com/api/v1/email/smtp-service"
      );
      http.setRequestHeader("Content-type", "application/json");
      http.send(
        JSON.stringify({
          payload: utdFormData,
          apiKey: "m11ddzmnrxy8zu3l1e",
        })
      );
      http.onload = () => {
        window.location.href = "https://www.m-bike.be/p/bedankt.html";
      };
      return false;
    };
    const form = document.getElementById("utd-form");
    if (form) {
      if (form.attachEvent) {
        form.attachEvent("submit", processForm);
      } else {
        form.addEventListener("submit", processForm);
      }
    }
  },
};
</script>
